// @flow
import type {
  Operation,
  // OperationError,
  CreateOperationArgs,
} from '../types'

// Libs
import _uniqueId from 'lodash/uniqueId'

// Constants
import { ADD, EDIT, DELETE, READ, OTHER } from './constants'

// Exports
export function createOperation<T: Object> ({
  model,
  type = OTHER,
  new: maybeNew,
  submitting: maybeSubmitting,
  errors: maybeErrors,
  success: maybeSuccess,
  }: CreateOperationArgs<T>): Operation<T> {
  return {
    model,
    operationId: _uniqueId(),
    operation: type,
    new: !!maybeNew,
    submitting: !!maybeSubmitting,
    errors: maybeErrors || [],
    success: !!maybeSuccess,
  }
}

export function addOperation<T: Object> ({
  model,
  submitting: maybeSubmitting,
  errors: maybeErrors,
  success: maybeSuccess,
  }: Operation<T>): Operation<T> {
  return {
    model,
    operationId: _uniqueId(),
    operation: ADD,
    new: true,
    submitting: !!maybeSubmitting,
    errors: maybeErrors || [],
    success: !!maybeSuccess,
  }
}

export function editOperation<T: Object> ({
  model,
  submitting: maybeSubmitting,
  errors: maybeErrors,
  success: maybeSuccess,
  }: Operation<T>): Operation<T> {
  return {
    model,
    operationId: _uniqueId(),
    operation: EDIT,
    new: false,
    submitting: !!maybeSubmitting,
    errors: maybeErrors || [],
    success: !!maybeSuccess,
  }
}

export function deleteOperation<T: Object> ({
  model,
  submitting: maybeSubmitting,
  errors: maybeErrors,
  success: maybeSuccess,
  }: Operation<T>): Operation<T> {
  return {
    model,
    operationId: _uniqueId(),
    operation: DELETE,
    new: false,
    submitting: !!maybeSubmitting,
    errors: maybeErrors || [],
    success: !!maybeSuccess,
  }
}

export function readOperation<T: Object> ({
  model,
  submitting: maybeSubmitting,
  errors: maybeErrors,
  success: maybeSuccess,
  }: Operation<T>): Operation<T> {
  return {
    model,
    operationId: _uniqueId(),
    operation: READ,
    new: true,
    submitting: !!maybeSubmitting,
    errors: maybeErrors || [],
    success: !!maybeSuccess,
  }
}
